export default __webpack_public_path__ + "static/verlaessliche.beratung-2c7e5147406a72b1deb8787181f703cc.jpg";